/**
 * Types
 */
export const Types = {
  GET_TOKEN: "login/GET_TOKEN",
  GET_EMAIL: "login/GET_EMAIL",
  KEEP_CONNECTED: "login/KEEP_CONNECTED",
  STEP: "STEP",
  RESET: "RESET",
  PASSWORD_WILL_EXPIRE: 'PASSWORD_WILL_EXPIRE',
  DISPLAY_NOTIFY_PASSWORD: 'DISPLAY_NOTIFY_PASSWORD'
};

/**
 * Reducers
 */
const INITIAL_STATE = {
  access_token: "",
  refresh_token: "",
  login_email: "",
  keepConnected: false,
  stepFirstAcess: 1,
  passwordWillExpire: false,
  expireInDays: 0,
  displayNotifyPassword: false,
};

/**
 * Actions
 */
export const Creators = {
  getToken: (access_token, refresh_token) => ({
    type: Types.GET_TOKEN,
    access_token,
    refresh_token,
  }),
  getEmail: (login_email) => ({
    type: Types.GET_EMAIL,
    login_email,
  }),
  handleKeepConnected: (keepConnected) => ({
    type: Types.KEEP_CONNECTED,
    keepConnected,
  }),
};

export default function loginReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET:
      return {
        access_token: "",
        refresh_token: "",
        login_email: "",
        keepConnected: false,
        passwordWillExpire: false,
        expireInDays: 0,
        displayNotifyPassword: false,
      };
    case Types.GET_TOKEN:
      return {
        ...state,
        access_token: action.access_token,
        refresh_token: action.refresh_token,
      };
    case Types.GET_EMAIL:
      return {
        ...state,
        login_email: action.login_email,
      };
    case Types.KEEP_CONNECTED:
      return {
        ...state,
        keepConnected: action.keepConnected,
      };
    case Types.STEP:
      return {
        ...state,
        stepFirstAcess: action.step
      };
    case Types.PASSWORD_WILL_EXPIRE:
      return {
        ...state,
        passwordWillExpire: true,
        expireInDays: action.expireInDays
      };
    case Types.DISPLAY_NOTIFY_PASSWORD:
      return {
        ...state,
        displayNotifyPassword: action.displayNotifyPassword
      };
    default:
      return state;
  }
}
